import type { PaginationProps, ResaleValueGuarantee } from 'modules/types'
import CONSTANT from 'modules/constant'
import { API, download, headers } from './api'

// Define the API response types based on the contract
export const resaleValueGuaranteeApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getRvgList: builder.mutation<PaginationProps<ResaleValueGuarantee>, FormData>({
      query: (formData) => ({
        url: CONSTANT.URL_RESALE_VALUE_GUARANTEE_LIST,
        method: 'POST',
        headers: headers({ useContentType: false }),
        body: formData
      })
    }),
    exportRvg: builder.mutation<Blob, FormData>({
      query: (formData) => ({
        url: CONSTANT.URL_RESALE_VALUE_GUARANTEE_DOWNLOAD,
        method: 'POST',
        headers: headers({ useContentType: false }),
        body: formData,
        responseHandler: download
      })
    })
  })
})

export const { useGetRvgListMutation, useExportRvgMutation } = resaleValueGuaranteeApi
